import React from 'react';
import Button from 'react-bootstrap/Button';
import Squeeze from './Squeeze';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const songs = location.state?.songs || [];

  const handleBack = () => {
    navigate('/builder');
  };

  return (
    <div>
      <Button variant="secondary" onClick={handleBack} className="mb-3">
        ← Back to Builder
      </Button>
      <h1> Search Results View: Filter or pick the songs to be added</h1>
      <Squeeze 
        list={songs} 
        closingModal={handleBack}
      />
    </div>
  );
};

export default SearchView;
